<template>
  <ModalFullscreen
    modal-id="modal-id-search"
    background-color="bg-primary-450"
    padding-class="c-px-0 c-pt-2"
  >
    <div class="text-primary c-flex-fill flex">
      <Search
        type="mobileSearchModal"
        :items="[products, categories]"
        @search-changed="searchChanged"
        @value-changed="searchValueChanged"
        @enter-pressed="goToSearchView"
        @close-btn-clicked="closeModal"
      >
        <template #items="itemsProps">
          <div class="row m-O border-bottom border-2 border-primary sticky z-11 top-0">
            <button
              type="button"
              class="col-6 btn btn-beige c-rounded-0 shadow-none"
              :class="{ focus: toggleTab }"
              @click="toggleTab = true"
            >
              {{ t('ready_mixes_title') }}
                  &nbsp;
              <strong class="text-xs-c">({{ itemsProps.items[0].length }})</strong>
            </button>
            <button
              type="button"
              class="col-6 btn btn-beige c-rounded-0 shadow-none"
              :class="{ focus: !toggleTab }"
              @click="toggleTab = false"
            >
              {{ t('categories') }}
                  &nbsp;
              <strong class="text-xs-c">({{ itemsProps.items[1].length }})</strong>
            </button>
          </div>
          <div
            v-if="toggleTab"
            class="c-flex-fill flex c-flex-col c-w-100"
          >
            <div
              v-if="itemsProps.items[0].length > 0 && isLoaded"
              class="bg-white mx-n2"
            >
              <ul class="list-unstyled c-m-0 c-pt-2 c-pb-5 c-justify-center row search-results-modal">
                <li
                  v-for="item in itemsProps.items[0]"
                  :key="item.id"
                  class="flex c-py-2 c-px-1 relative col-10 c-sm:col-7"
                  :class="{ 'item-show': itemsProps.items[0].length > 0 }"
                >
                  <div class="row c-flex-grow-1 c-items-center item relative">
                    <div class="col-4 c-md:col-2 c-px-1">
                      <div
                        v-if="item.images.length > 0"
                        class="c-mb-0 c-flex-grow-1"
                      >
                        <RemoteResponsiveImage
                          :product-image-data="item.images[0]?.data"
                          img-class="modal_mobile_search-img image-cover"
                          :alt="item.name"
                          sizes="25vw"
                        />
                      </div>
                    </div>
                    <div class="c-md:col-10 col-8 c-px-1">
                      <router-link
                        class="block c-p-1 text-sm-c c-flex-grow-1 c-leading-sm stretched-link z-1"
                        :to="{ name: 'productPath', params: { permalink: item.permalink } }"
                      >
                        <span class="block">{{ item.name }}</span>
                        <strong class="text-sm-c">
                          <span v-if="item.quantityDiscounts">
                            {{
                              discountPriceFormatter(
                                showFromLabel(item.quantityDiscounts, item.plusClubPrice) ? t('from') : '',
                                item.plusClubPrice,
                                getCurrentCustomer?.inPlusClub,
                                item.quantityDiscounts[0].price,
                                item.quantityDiscounts[item.quantityDiscounts.length - 1].price,
                                item.currency,
                              )
                            }}
                          </span>
                          <span v-else>{{ numberToCurrency(item.price, item.currency) }}</span>
                        </strong>
                      </router-link>
                      <div class="relative c-float-right mt-n2 z-2">
                        <AddToCartButton
                          v-if="!item.isIngredient && item.state === 'available'"
                          :icon-button-only="true"
                          :product="item"
                          gtm-source="navbar-products-search"
                        />
                        <router-link
                          v-else
                          v-close-popper
                          :to="{ name: 'productPath', params: { permalink: item.permalink } }"
                          type="button"
                          class="btn btn-warning c-p-2 stretched-link c-rounded-circle"
                          data-toggle="product-detail-modal"
                          aria-label="product info"
                        >
                          <i class="mi-info icon-14" />
                        </router-link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <button
                class="btn  btn-primary c-px-5 c-md:c-px-3 c-xl:c-px-5 font-medium c-rounded-0 sticky z-11  bottom-0 c-w-100"
                type="button"
                @click="goToSearchView"
              >
                {{ t('show_all_results') }}
              </button>
            </div>
            <div
              v-else-if="searchText && isLoaded"
              class="bg-white c-pt-5 c-pb-5 mx-n2 c-flex-fill row c-justify-center c-pl-3 c-pr-3"
            >
              <div class="container">
                <span class="text-primary opacity-20 c-pb-4 block text-center">
                  <i class="mi-search-err icon-40" />
                </span>
                <h4 class="text-primary c-mb-5 opacity-30 text-center block">
                  {{ t('we_do_not_know_this_beak') }}
                </h4>
                <hr>
                <h4 class="text-primary c-mb-2 c-mt-5 text-center block">
                  {{ t('bestsellers') }}
                </h4>
                <Carousel
                  v-if="crossSell?.length > 0"
                  :slides="crossSell"
                  class="col-12"
                />
              </div>
            </div>
            <div
              v-else-if="itemsProps.items[0].length === 0 && !searchText"
              class="bg-white c-pt-5 c-pb-5 mx-n2 c-flex-fill c-flex-col c-justify-center"
            >
              <div class="container">
                <span class="text-primary opacity-20 c-pb-4 block text-center">
                  <i class="mi-search icon-40" />
                </span>
                <h4 class="text-primary c-mb-5 opacity-30 text-center block">
                  {{ t('search_text') }}
                </h4>
                <hr>
                <h4 class="text-primary c-mb-2 c-mt-5 text-center block">
                  {{ t('bestsellers') }}
                </h4>
                <Carousel
                  v-if="crossSell?.length > 0"
                  :slides="crossSell"
                  class="col-12"
                />
              </div>
            </div>
            <div
              v-else
              class="bg-white c-pt-5 c-pb-5 mx-n2 c-flex-fill row c-justify-center"
            >
              <BaseLoading :style="{ minHeight: '30vh' }" />
            </div>
          </div>
          <div
            v-else
            class="c-flex-fill flex c-flex-col c-w-100"
          >
            <ul
              v-if="itemsProps.items[1].length > 0 && isLoaded"
              class="list-unstyled c-m-0 bg-white c-pt-2 c-pb-5 mx-n2 c-justify-center row search-results-modal"
            >
              <li
                v-for="category in itemsProps.items[1]"
                :key="category.systemName"
                class="flex c-py-2 c-px-1 relative col-10 c-sm:col-7"
              >
                <div class="row c-flex-grow-1 c-items-center item relative">
                  <div class="col-4 c-lg:col-2 c-px-1">
                    <div class="embed-responsive embed-responsive-4by3 c-mb-0 c-rounded-sm">
                      <RemoteImage
                        :src="`https://img.mix.it/general_assets/categories/${category.image}`"
                        img-class="embed-responsive-item image-contain"
                        :alt="category.title"
                      />
                    </div>
                  </div>
                  <div class="col-8 c-lg:col-10 c-px-1">
                    <router-link
                      v-close-popper
                      :to="{ name: 'productsPath', params: { permalink: category.permalink } }"
                      class="block stretched-link font-medium hover-underline c-leading-sm"
                    >
                      {{ category.title }}
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
            <div
              v-else-if="searchText && isLoaded"
              class="bg-white c-pt-5 c-pb-5 mx-n2 c-flex-fill row c-justify-center c-pl-3 c-pr-3"
            >
              <div class="container">
                <span class="text-primary opacity-20 c-pb-4 block text-center">
                  <i class="mi-search-err icon-40" />
                </span>
                <h4 class="text-primary c-mb-5 opacity-30 text-center block">
                  {{ t('we_do_not_know_this_beak') }}
                </h4>
                <hr>
                <h4 class="text-primary c-mb-2 c-mt-5 text-center block">
                  {{ t('bestsellers') }}
                </h4>
                <Carousel
                  v-if="crossSell?.length > 0"
                  :slides="crossSell"
                  class="col-12"
                />
              </div>
            </div>
            <div
              v-else-if="itemsProps.items[1].length === 0 && !searchText"
              class="bg-white c-pt-5 c-pb-5 mx-n2 c-flex-fill row c-justify-center"
            >
              <span class="text-primary opacity-20 c-mt-5 c-pb-4 block text-center">
                <i class="mi-search icon-180" />
              </span>
              <h4 class="text-primary c-mb-0 c-mt-5 opacity-30 text-center block">
                {{ t('search_text') }}
              </h4>
            </div>
            <div
              v-else
              class="bg-white c-pt-5 c-pb-5 mx-n2 c-flex-fill row c-justify-center"
            >
              <BaseLoading :style="{ minHeight: '30vh' }" />
            </div>
          </div>
        </template>
      </Search>
    </div>
  </ModalFullscreen>
  <BaseModal
    :title="t('watchdog_title')"
    modal-id="modal-watchdog"
  >
    <ModalWatchdog />
  </BaseModal>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import RetailApiV2 from '@/api/retailApi/RetailApiV2'
import AddToCartButton from '@/components/buttons/ButtonAddToCartButton.vue'
import BaseLoading from '@/components/general/BaseLoading.vue'
import BaseModal from '@/components/general/BaseModal.vue'
import ModalFullscreen from '@/components/general/BaseModalFullscreen.vue'
import RemoteImage from '@/components/general/BaseRemoteImage.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import Search from '@/components/general/BaseSearch.vue'
import ModalWatchdog from '@/components/modals/ModalWatchdog.vue'
import { discountPriceFormatter } from '@/mixins/discountPriceFormatter'
import { numberToCurrency } from '@/mixins/numberToCurrency'
import { useAppStore } from '@/stores/AppStore'
import { useModalStore } from '@/stores/ModalStore'
import Carousel from '@/components/carousel/Carousel.vue'
import { useProductStore } from '@/stores/ProductStore'

const appStore = useAppStore()
const { getCurrentCustomer } = storeToRefs(appStore)

const { t } = useI18n()

const router = useRouter()
const products = ref([])
const categories = ref([])
const searchText = ref()
const toggleTab = ref(true)
const isLoaded = ref(false)

const productStore = useProductStore()
const { closeModal } = useModalStore()
const searchValueChanged = (value) => {
  searchText.value = value
}
const searchChanged = async (value) => {
  searchText.value = value
  isLoaded.value = false
  if (value.length > 0) {
    const { data } = await RetailApiV2.get(`search?q=${value}&limit=30&variant=modest`)
    products.value = data.products
    categories.value = data.categories
    isLoaded.value = true
  } else {
    products.value = []
    categories.value = []
    isLoaded.value = false
  }
}
const goToSearchView = () => {
  const url = router.resolve({ name: 'searchPath', params: { search: searchText.value } })
  window.location.href = url.href
}

// Defines if "From [some price]" label should be visible.
const showFromLabel = (quantityDiscounts, plusClubPrice) => {
  return quantityDiscounts && (!plusClubPrice || !getCurrentCustomer.value?.inPlusClub)
}

const crossSell = ref()

const loadCrossSell = async () => {
  crossSell.value = await productStore.loadCrossSell('quantity=6&kind=homepage_favorite_cross_sell')
}

loadCrossSell()
</script>

<style lang="scss">
.modal_mobile_search-img {
  width: 88px;
  height: 66px;
}
</style>

<i18n>
  {
    "cs": {
    "bestsellers": "Bestsellery",
    "categories": "Kategorie",
    "from": "Od",
    "ready_mixes_title": "Produkty",
    "search_text": "Napište, jaké dobroty hledáte",
    "show_all_results": "Zobrazit všechny výsledky",
    "watchdog_title": "Chcete si počkat?",
    "we_do_not_know_this_beak": "Bohužel tohle zobání jsme nenašli. Zkuste kouknout po jiném."
},
    "sk": {
    "bestsellers": "Bestsellery",
    "categories": "Kategórie",
    "from": "Od",
    "ready_mixes_title": "Produkty",
    "search_text": "Napíšte, aké dobroty hľadáte",
    "show_all_results": "Zobraziť všetky výsledky",
    "watchdog_title": "Chcete si počkať?",
    "we_do_not_know_this_beak": "Bohužiaľ toto zobkanie sme nenašli. Skúste sa pozrieť po inom."
},
    "pl": {
    "bestsellers": "Bestsellery",
    "categories": "Kategorie",
    "from": "Od",
    "ready_mixes_title": "Produkty",
    "search_text": "Napisz, jakich przekąsek szukasz",
    "show_all_results": "Pokaż wszystkie wyniki",
    "watchdog_title": "Chcesz poczekać?",
    "we_do_not_know_this_beak": "Niestety nie znaleźliśmy tego smakołyku. Spróbuj znaleźć coś innego."
},
    "hu": {
    "bestsellers": "Bestsellerek",
    "categories": "Kategóriák",
    "from": "Ft-tól",
    "ready_mixes_title": "Termékek",
    "search_text": "Írd le, milyen finomságokat keresel",
    "show_all_results": "Minden eredmény megtekintése",
    "watchdog_title": "Szeretnél várni?",
    "we_do_not_know_this_beak": "Sajnos ezt a falatot nem találtuk. Próbálj meg másikat keresni."
},
    "de": {
    "bestsellers": "Bestseller",
    "categories": "Kategorie",
    "from": "Von",
    "ready_mixes_title": "Produkte",
    "search_text": "Schreib uns, welche Leckereien du suchst",
    "show_all_results": "Alle Ergebnisse anzeigen",
    "watchdog_title": "Möchtest du warten?",
    "we_do_not_know_this_beak": "Leider haben wir diesen Snack nicht gefunden. Versuche, einen anderen zu finden."
},
    "at": {
    "bestsellers": "Bestseller",
    "categories": "Kategorie",
    "from": "Von",
    "ready_mixes_title": "Produkte",
    "search_text": "Schreib uns, welche Leckereien du suchst",
    "show_all_results": "Alle Ergebnisse anzeigen",
    "watchdog_title": "Möchtest du warten?",
    "we_do_not_know_this_beak": "Leider haben wir diesen Snack nicht gefunden. Versuche, einen anderen zu finden."
},
    "ro": {
    "bestsellers": "Cele mai vândute",
    "categories": "Categorii",
    "from": "De la",
    "ready_mixes_title": "Produse",
    "search_text": "Scrieți ce bunătăți căutați",
    "show_all_results": "Vizualizează toate rezultatele",
    "watchdog_title": "Dorești să aștepți?",
    "we_do_not_know_this_beak": "Din păcate, nu am găsit această bunătate. Încearcă să cauți alta."
},
    "fr": {
    "bestsellers": "Best-sellers",
    "categories": "Catégories",
    "from": "À partir de",
    "ready_mixes_title": "Produits",
    "search_text": "Dites-nous quelle gourmandise vous cherchez",
    "show_all_results": "Afficher tous les résultats",
    "watchdog_title": "Voulez-vous patienter ?",
    "we_do_not_know_this_beak": "Malheureusement, nous n’avons pas trouvé ce produit. Essayez d’en chercher un autre !"
},
    "it": {
    "bestsellers": "Bestseller",
    "categories": "Categoria",
    "from": "Da",
    "ready_mixes_title": "Prodotti",
    "search_text": "Scrivi quali prelibatezze stai cercando",
    "show_all_results": "Mostra tutti i risultati",
    "watchdog_title": "Vuoi aspettare?",
    "we_do_not_know_this_beak": "Purtroppo non abbiamo trovato questo spuntino. Prova a cercarne un altro."
}
  }
</i18n>
